import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import FounderSection from "@/components/FounderSection";
import Footer from "@/components/Footer";

const Team = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const title = "Команда WMT AI | Эксперты по ИИ-трансформации и обучению для бизнеса";
    const description = "Команда WMT AI помогает среднему и крупному бизнесу внедрять ИИ: от аудита и стратегии до цифровых сотрудников, ИИ-архитектуры, «Нейроключа» и обучения команд | Игорь Никитин, Андрей Майнгардт и Юлия Болтуцкая";
    document.title = title;

    const updates = [
      { selector: 'meta[name="description"]', tag: "meta", key: "content", value: description, attributes: { name: "description" } },
      { selector: 'link[rel="canonical"]', tag: "link", key: "href", value: "https://wmt-ai.ru/team/", attributes: { rel: "canonical" } },
      { selector: 'meta[property="og:title"]', tag: "meta", key: "content", value: title, attributes: { property: "og:title" } },
      { selector: 'meta[property="og:description"]', tag: "meta", key: "content", value: description, attributes: { property: "og:description" } },
      { selector: 'meta[property="og:url"]', tag: "meta", key: "content", value: "https://wmt-ai.ru/team/", attributes: { property: "og:url" } },
      { selector: 'meta[name="twitter:title"]', tag: "meta", key: "content", value: title, attributes: { name: "twitter:title" } },
      { selector: 'meta[name="twitter:description"]', tag: "meta", key: "content", value: description, attributes: { name: "twitter:description" } },
    ];
    const cleanups = updates.map((update) => {
      const existing = document.head.querySelector(update.selector);
      const element = existing ?? document.createElement(update.tag);
      const previous = element.getAttribute(update.key);
      Object.entries(update.attributes).forEach(([key, value]) => element.setAttribute(key, value));
      element.setAttribute(update.key, update.value);
      if (!existing) document.head.append(element);
      return () => {
        if (!existing) element.remove();
        else if (previous === null) element.removeAttribute(update.key);
        else element.setAttribute(update.key, previous);
      };
    });

    return () => {
      document.title = previousTitle;
      cleanups.forEach((cleanup) => cleanup());
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="pt-16">
        <FounderSection headingAs="h1" />
      </main>
      <Footer />
    </div>
  );
};

export default Team;
